storefrontApp.service("productService", [
    "$http",
    function (
        $http
    ) {
        return {
            isPatchEligible: function (productId) {
                return $http.get('storefrontapi/ispatchconversioneligible?productId=' + productId);
            },
            getPatchContent: function () {
                return $http.get('storefrontapi/patchcontent');
            },
            submitLowerPriceRequest: function (lowerPrice) {
                return $http.post('storefrontapi/contact/lowerprice', lowerPrice);
            },
            isColorChartAvailable: function (fileSubpath, fileType) {
                return $http.get('storefrontapi/isFileAvailable?fileSubpath=' + fileSubpath + '&fileType=' + fileType);
            },
            getInspirationImages: function (productId, definition, brand) {
                return $http.get('storefrontapi/inspirations?productId=' + productId + '&definition=' + definition + '&brand=' + brand);
            },
            checkProductVideosExists: function (productId, brand) {
                return $http.get('storefrontapi/checkproductvideosexists?productId=' + productId + '&brand=' + brand);
            },
            getThreadMfgByCatalog: function (catalogId) {
                return $http.get('storefrontapi/threadmfgbycatalog?catalogId=' + catalogId);
            },
            getThreadConverterColorChart: function (colorCodes, threadMfg, isProductPage) {
                if (colorCodes != null && colorCodes.length > 0) {
                    var requestData = {
                        ColorCodes: colorCodes,
                        ThreadMfg: threadMfg,
                        IsProductPage: isProductPage
                    };
                    return $http.post('storefrontapi/threadconvertercolorchart', requestData);
                }
                else {
                    return null;
                }
            },
            getShippingEstimate: function (shippingInformation) {
                return $http.post('storefrontapi/shipping/estimate', shippingInformation);
            },
            hasInventory: function (productId) {
                return $http.get('storefrontapi/product/inventory/' + productId);
            },
            getCountries: function () {
                return $http.get('storefrontapi/countries?t=' + new Date().getTime());
            },
            isfreeShippable: function (productId, catalog) {
                return $http.get('storefrontapi/shipping/freeshipping?productId=' + productId + '&catalog=' + catalog);
            },
            insertNotifyInStock: function (queue) {
                return $http.post('storefrontapi/insertnotifyinstock', queue);
            },
            getProjectPDFUrl: function (projectId) {
                return $http.get('storefrontapi/learningcenter/projectpdfurlbyid?projId=' + projectId);
            },
            checkProjectExists: function (productId) {
                return $http.get('storefrontapi/learningcenter/getproductprojects?itemId=' + productId);
            },
            checkIfProductHasPdf: function (catalogId, itemId) {
                return $http.get('storefrontapi/learningcenter/checkpdfexists?vendorCode=' + catalogId + '&itemId=' + itemId);
            },
            getSaleitemkeyfeatures: function (productId) {
                return $http.get('storefrontapi/product/getsaleitemfeatures?itemId=' + productId);
            },
            getModuleKeys: function (key) {
                return $http.get("storefrontapi/modulekeys?key=" + key);
            },
            sendEmailOnReferProduct: function (formData) {
                return $http.post(
                    "storefrontapi/product/refer",
                    formData,
                    {
                        headers: { "Content-Type": undefined },
                    }
                );
            },
            getRelatedSales: function (productId) {
                return $http.get('storefrontapi/getrelatedsales?itemId=' + productId);
            },
            getPatchContent: function () {
                return $http.get('storefrontapi/patchcontent');
            },
            getPatchesCategories: function () {
                return $http.get("storefrontapi/getfabriccategories");
            },


        }
    }
]);
